import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

export interface EntityLabelsItemProps {
    recordId: string;
    isDisabled: boolean;
    onClick: () => void;
    onRemove: () => void;
    correctionSelected: boolean;
}

/**
 * This is the entry in the list of DCFs that will be available to the user.
 */
export const EntityLabelsItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected }: EntityLabelsItemProps): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title="Move Session"
            description="Change any of the Participant, visit or session labels for this particular session."
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
